/**
 * 工單費用（be doc dd7f0319 #41／#43）。
 * - 第一版全部 TWD；名稱可重複；既有項目不可移除，停止收取改金額 0。
 * - 表單列：`{ expenseId, name, amount }`；`expenseId` 空字串＝新項目（避免與 useFieldArray 的 id 衝突）。
 * - 寫入：`{ id?, name, amount }`，順序即 display_order。
 */

/** 最多 15 位整數、4 位小數（BE numeric 精度）。 */
const AMOUNT_PATTERN = /^\d{1,15}(\.\d{1,4})?$/;

export function isValidExpenseAmount(value) {
  if (value === '' || value == null) {
    return false;
  }
  return AMOUNT_PATTERN.test(String(value).trim());
}

export function createEmptyExpenseRow() {
  return { expenseId: '', name: '', amount: '' };
}

/** detail `expenses[]` → 表單列（依 display_order）。 */
export function mapExpensesToFormRows(expenses = []) {
  return [...(expenses ?? [])]
    .sort((left, right) => (left?.displayOrder ?? 0) - (right?.displayOrder ?? 0))
    .map((row) => ({
      expenseId: row?.id ?? '',
      name: row?.name ?? '',
      amount: row?.amount == null ? '' : String(row.amount),
    }));
}

/** 表單列 → 寫入 `expenses[]`。 */
export function buildExpensesWritePayload(rows = []) {
  return (rows ?? []).map((row) => {
    const item = {
      name: String(row?.name ?? '').trim(),
      amount: Number(String(row?.amount ?? '').trim()),
    };
    if (row?.expenseId) {
      return { id: row.expenseId, ...item };
    }
    return item;
  });
}

/** 與載入值相同時不送 `expenses`（省略＝BE 不讀不改，也不遞增 revision）。 */
export function isExpensesChanged(rows = [], originalRows = []) {
  return JSON.stringify(buildExpensesWritePayload(rows))
    !== JSON.stringify(buildExpensesWritePayload(originalRows));
}

export function sumExpenseAmounts(expenses = []) {
  return (expenses ?? []).reduce((total, row) => {
    const amount = Number(row?.amount);
    return Number.isFinite(amount) ? total + amount : total;
  }, 0);
}
